import React from 'react'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'

// The shared card every ePCR module section sits in - restyled 2026-11 to
// match the live-console look (flat, bordered, rounded) so the whole record
// editor modernises from one place.
const EPCRCard = (props) => (
  <Stack
    gap={1.25}
    padding={{ xs: 1.5, md: 2 }}
    component={Paper}
    elevation={0}
    sx={{
      borderRadius: 2,
      border: '1px solid rgba(15,23,42,0.08)',
      backgroundColor: '#fff',
      ...(props.sx ?? {}),
    }}
  >
    {props.children}
  </Stack>
)

export default EPCRCard
